import React, { useEffect } from 'react';

import { DefaultLayout } from 'common/components/AppLayout/DefaultLayout';
import { CwRUMScript } from 'common/components/CwRUM/index';
import { SCode } from 'common/components/sCode';
import { Panorama } from 'common/components/Panorama';
import ErrorBoundary from 'common/components/ErrorBoundary';
import { APP_CONTENT_ID } from 'common/constants';
import { getConfig } from '@amzn/aws-howser-client-config';
import { enableABTestingPOC } from 'common/utils/featureFlag';

declare global {
  interface Window {
    AWSMA: {
      TRIGGER_EVENT: string;
      config: any;
      ready: any;
    };
    panorama: any;
  }
}

const App: React.FC = () => {
  const howserConfig = getConfig('howserService'); //loads the hoserService Config
  useEffect(() => {
    if (howserConfig?.enableAdobeAnalytics) {
      window.AWSMA = window.AWSMA || { config: {} };
      setTimeout(() => {
        //Setimeout will activate the customPageView after 1s to send the metrics info on initial page load and then switch to SPA config
        window.AWSMA.config.customPageview = true;
      }, 500);
    }
  }, [howserConfig?.enableAdobeAnalytics]);
  return (
    <div id={APP_CONTENT_ID}>
      {howserConfig?.enableAdobeAnalytics && <SCode />}
      {enableABTestingPOC() && <Panorama />}
      <CwRUMScript />
      <ErrorBoundary>
        <DefaultLayout />
      </ErrorBoundary>
    </div>
  );
};

export default App;
